<template>
  <AttachmentsList
      ref="list"
      @list-of-attachments="openAttachments"
      :number-of-attachments="numberOfAttachments"
      :unsaved-attachments="numberOfUnsavedAttachments"
      :attachment-lists="attachmentsList"
      :read-only="readOnly"
      :validated-field="validatedField"
      :field-config="fieldConfig"
  ></AttachmentsList>
</template>

<script>

import FormValidatedField from "@/components/forms/FormValidatedField";

import AttachmentsList from "@/components/list/AttachmentsList";
import {getFileSizeFormatter} from "@/components/datagrid/ColumnFormatter";
import ActivityManager from "@/activity/ActivityManager";
import FormsAI from "@/components/forms/FormsAI";
import AttachmentsFormFieldConfig
  from "@/server/com/silkplm/engine/forms/schema/definition/AttachmentsFormFieldConfig";
import RpcInputValidationException from "@/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException";

const AttachmentsActivity = () => require("@/components/forms/renderers/attachments/AttachmentsActivity");

export default {
  name: "AttachmentsRenderer",
  components: {AttachmentsList},
  mounted(){
    this.loadAttachments();
  },
  props:{
    validatedField: { type: FormValidatedField, required:true },
    fieldConfig: { type: AttachmentsFormFieldConfig, required:true },
    mode: {default: null},
  },

  methods:{
    setReadOnly(readOnly) {
      this.readOnly = readOnly;
    },

    setEditorMode(val){
      this.editorMode = val;
    },

    getAttachmentsData() {
      let result = {
        "numberOfAttachments" : this.numberOfAttachments,
        "attachmentsList" : this.attachmentsList,
      }
      return result;
    },

    setAttachmentsData(result) {
      this.numberOfAttachments = result["numberOfAttachments"];
      this.attachmentsList = result["attachmentsList"];
    },

    async loadAttachments() {
      try {
        this.frozenWatch = true;
        if (this.validatedField.value) {
          this.numberOfAttachments = this.validatedField.value.length;
          this.attachmentsList = [...this.validatedField.value];
          let initialValue = this.validatedField.value;
          this.validatedField.value = null;
          this.validatedField.value = initialValue;
          this.firstInitial = false;
        } else {
          this.attachmentsList = [];
        }
        for (let i = 0; i < this.attachmentsList.length; i++) {
          this.attachmentsList[i].data.sizeLabel = getFileSizeFormatter(this.attachmentsList[i].data.size);
        }
      } finally {
        this.$nextTick(() => {
          this.frozenWatch = false;
        });
      }
    },

    fixResultOfAttachments(removedTokens) {
      this.attachmentsList = _.filter(this.attachmentsList, (attachment) => {
        return !_.includes(removedTokens, attachment.token);
      });
      this.validatedField.value = this.attachmentsList;
      this.numberOfAttachments = this.attachmentsList.length;
    },

    async openAttachments() {
      let entityId = this.validatedField.validatedForm?.originalSource?.id;

      const activity = await ActivityManager.showActivity(AttachmentsActivity, {
        attachments: this.attachmentsList,
        validatedField: this.validatedField,
        canEdit: !this.fieldConfig.readOnly,
        isJoined: this.fieldConfig.joined,
        editMode: (!this.readOnly && !this.fieldConfig.readOnly) || !entityId,
        title: this.fieldConfig.fieldLabel + " - " +
            FormsAI.getEntityLabel(this.validatedField.getFormConfig(),
                this.validatedField.validatedForm.originalSource)
      });

      let handler;
      activity.$on('save',handler = async attachmentDialogResult => {
        if (attachmentDialogResult.numberOfUnsavedAttachments) {
          this.attachmentsList = attachmentDialogResult.attachmentsList;
          this.validatedField.value = this.attachmentsList;
          this.numberOfAttachments = this.attachmentsList.length;
          if (entityId) {
            await this.validatedField.saveField();
          }
        }
        this.fixResultOfAttachments(attachmentDialogResult.deletedTokens);
      });

      activity.$on('close', handler = async unsavedTokens => {
        this.fixResultOfAttachments(unsavedTokens);
      });

      await activity.getResult();
      activity.$off('save', handler);
      activity.$off('close', handler);
    },

  },
  watch: {
    'validatedField': async function (val) {
      if (!this.frozenWatch) {
        await this.loadAttachments();
      }
    },
    'validatedField.value': async function (val) {
      if (!this.frozenWatch) {
        await this.loadAttachments();
      }
    }
  },
  data: () => ({
    readOnly: true,
    editorMode: false,
    numberOfAttachments: 0,
    numberOfUnsavedAttachments: 0,
    attachmentsList: [],
    firstInitial: true,
    frozenWatch: false,
  })
}
</script>

<style scoped>

</style>